import { TableHead, SearchData } from "../../../../common/dataClass/Default"
import { ProductList } from '../productInfo/class'

/**搜索数据 */
class ProductReservesSearchData extends SearchData{
  constructor() {
    super()
    /**创建日期 */
    this.createdDate = ''
    /**交货日期 */
    this.deliveryDate = ''
    /**采购状态 */
    this.purchaseStatus = ''
    /**入仓状态 */
    this.warehousingStatus = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    return {
      page: this.page,
      row: 10,
      saleStatus: 0,
      storeName: this.store? this.store : null,
      countryArea: this.countrySite? this.countrySite : null,
      textFilter: this.text? this.text : null
    }
  }
}

/**产品储备计划单表头 */
class ProductReservestTableHead extends TableHead{
  constructor(name, prop, width, obj) {
    super(name, prop, width, obj)
  }
}

/**产品储备计划数据 */
class ProductReservest extends ProductList{
  constructor(bool) {
    super()
    /**计划储备数量 */
    this.num = null
    this['^input-_^num'] = false
    /**整箱数量 */
    this._numByBox = null
    /**已装数量 */
    this._numInBox = null
    /**散装数量 */
    this._numByLast = null
    /**产品标贴 */
    this.productPdf = ''
    /**装箱状态 */
    this.boxStatus = -1
    /**操作状态 */
    this['^operate-_^'] = bool
  }
  set numByBox(val){
    this._numByBox = val
  }
  get numByBox(){
    return this._numByBox === null ? '------': this._numByBox
  }
  set numInBox(val){
    this._numInBox = val
  }
  get numInBox(){
    return this._numInBox === null ? '------': this._numInBox
  }
  set numByLast(val){
    this._numByLast = val
    if(val === null){
      this.boxStatus = -1
    }else if(val == 0){
      this.boxStatus = 0
    }else{
      this.boxStatus = 1
    }
  }
  get numByLast(){
    return this._numByLast === null ? '------': this._numByLast
  }
  get boxStatusText(){
    let obj = {
      '-1': '------',
      '0': '整箱',
      '1': '有尾箱'
    }
    return obj[this.boxStatus]
  }
  /**导入自身数据 */
  importParentData(obj){
    let keys = Object.keys(new ProductList)
    keys.map(key => this[key] = obj[key])
  }
}

class ProductReservestNewModule{
  /**产品储备计划单表头 */
  static NEWTABLEHEAD(){
    let arr = [
      new ProductReservestTableHead('产品储备计划单号', 'img', '250'),
      new ProductReservestTableHead('计划交货日期<br>实际交货日期', 'getCostOfCommodityInvestmentByTable', '250'),
      new ProductReservestTableHead('采购单<br>创建日期', 'getNetProfitOfGoodsByTable', '200'),
      new ProductReservestTableHead('总箱数', 'stockPrice', '100'),
      new ProductReservestTableHead('总重量<br>(kg)', 'getSavePriceByTable', '100'),
      new ProductReservestTableHead('总体积<br>(M³)', 'getCostSummaryByTable', '100'),
      new ProductReservestTableHead('产品型号数量', 'disposalNum', '100'),
      new ProductReservestTableHead('采购状态', 'getShowNumAndActualNumByTable', '200'),
      new ProductReservestTableHead('采购入仓状态', 'stockPrice', '200'),
      new ProductReservestTableHead('创建日期', 'disposalNum', '120'),
      new ProductReservestTableHead('操作', 'operate', '80'),
    ]
    return arr
  }
  /**产品储备产品表头 */
  static NEWPRODUCTTABLEHEAD(){
    let arr = [
      new ProductReservestTableHead('选择', 'check', '40'),
      new ProductReservestTableHead('产品图片', 'img', '100'),
      new ProductReservestTableHead('产品型号', 'model', '100'),
      new ProductReservestTableHead('产品名称', 'name', '150'),
      new ProductReservestTableHead('计价单位', '_unit', '80'),
      new ProductReservestTableHead('产品包装尺寸<br>(cm)', 'productSize', '150'),
      new ProductReservestTableHead('产品包装重量<br>(kg/单位)', 'weight', '150'),
      new ProductReservestTableHead('外箱包装尺寸<br>(cm)', 'boxSize', '150'),
      new ProductReservestTableHead('外箱包装重量<br>(kg/单位)', 'boxWeight', '150'),
      new ProductReservestTableHead('装箱数量', 'boxNum', '100'),
    ]
    return arr
  }
  /**产品储备装箱情况表头 */
  static NEWNUMTABLEHEAD(){
    let arr = [
      new ProductReservestTableHead('产品图片', 'img', '100'),
      new ProductReservestTableHead('产品名称', 'name', '100'),
      new ProductReservestTableHead('计价单位', '_unit', '100'),
      new ProductReservestTableHead('产品包装尺寸<br>(cm)', 'productSize', '150'),
      new ProductReservestTableHead('产品包装重量<br>(kg/单位)', 'weight', '150'),
      new ProductReservestTableHead('外箱包装尺寸<br>(cm)', 'boxSize', '150'),
      new ProductReservestTableHead('外箱包装重量<br>(kg/单位)', 'boxWeight', '150'),
      new ProductReservestTableHead('装箱数量<br>(单位/箱)', 'boxNum', '100'),
      new ProductReservestTableHead('产品标贴', '^file-_^boxPdf', '150'),
      new ProductReservestTableHead('计划储备数量', '^input-_^num', '150'),
      new ProductReservestTableHead('装箱数量<br>(箱)', 'numByBox', '100'),
      new ProductReservestTableHead('已装数量', 'numInBox', '100'),
      new ProductReservestTableHead('散装数量', 'numByLast', '100'),
      new ProductReservestTableHead('装箱状态', 'boxStatusText', '100'),
      new ProductReservestTableHead('操作', 'operate', '100'),
    ]
    return arr
  }
  /**新建尾箱表头 */
  static NEWTRUNKTABLEHEAD(){
    let arr = [
      new ProductReservestTableHead('选择', 'check', '40'),
      new ProductReservestTableHead('产品图片', 'img', '60'),
      new ProductReservestTableHead('产品型号', 'model', '100'),
      new ProductReservestTableHead('产品名称', 'name', '100'),
      new ProductReservestTableHead('计价单位', '_unit', '60'),
      new ProductReservestTableHead('产品包装尺寸<br>(cm)', 'productSize', '140'),
      new ProductReservestTableHead('产品包装重量<br>(kg/单位)', 'weight', '140'),
      new ProductReservestTableHead('箱内该商品数量', '^input-_^num', '100'),
      new ProductReservestTableHead('箱数', 'numByBox', '60'),
      new ProductReservestTableHead('剩余未入箱数量', 'numByLast', '80'),
    ]
    return arr
  }
  /**创建进度条数据 */
  static NEWPROGRESSARRAY(){
    let arr = [
      '选择计划储备的产品',
      '输入产品计划储备数量及计划交货日期等信息',
      '点击生成产品储备计划单'
    ]
    return arr
  }
}

export { ProductReservestNewModule, ProductReservesSearchData, ProductList, ProductReservest }
